import React from "react";
import { levels } from "../../mock/mockData";
import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { SideIllustration } from "../../components/common/SideIllustration";
import { IMAGE_SOURCES } from "../../mock/imageSources";

export default function VocalsDetail() {
  return (
    <div className="space-y-8">
      <header className="grid gap-6 md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:items-center">
        <div className="space-y-3">
          <h1 className="text-2xl font-semibold tracking-tight text-slate-900">
            Vocals (Western Contemporary / Indian Classical)
          </h1>
          <p className="max-w-2xl text-sm leading-relaxed text-slate-700 sm:text-base">
            The vocal syllabus includes pathways in Western contemporary singing, Hindustani classical vocal music and Bollywood playback-oriented performance. Candidates focus on breath control, pitch, diction and stylistic interpretation.
          </p>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.vocalsDetail}
          alt="Vocalist performing in a recital or examination setting"
        />
      </header>

      <section className="space-y-4">
        <h2 className="text-base font-semibold tracking-tight text-slate-900">Levels 16 overview</h2>
        <div className="grid gap-4 md:grid-cols-3">
          {levels.map((level) => (
            <Card key={level.id} className="border-slate-200 bg-white/80 shadow-sm backdrop-blur-xl">
              <CardHeader className="pb-2">
                <CardTitle className="text-sm font-semibold text-slate-900">
                  {level.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-2 text-sm text-slate-700">
                <p>{level.descriptor}</p>
                <p className="text-xs text-slate-500">
                  Level requirements typically combine technical exercises, scale patterns and songs or bandish / compositions chosen from Western and Indian classical or film repertoire, as appropriate to the candidate&apos;s pathway.
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </section>
    </div>
  );
}
